import React from 'react';
import Images from '../assets/AllImages';

const MEMBERSHIP = () => {
    return (
        <>

            <main>
                <div className="container-fluid bg-primary py-3 py-md-0">
                    <div className="row  align-items-center">
                        <div className="col-12 col-md-6 px-5">
                            <h5 className='text-white fw-bold my-0'>MEMBERSHIP</h5>
                        </div>

                        <div className="col-12 col-md-6 px-5 d-none d-sm-block">
                            <img src={Images.Vactor2} alt="" className='w-50 float-end' />
                        </div>
                    </div>
                </div>
            </main>

            {/* Create a Banner Section */}
            <div className="container-fluid membership-banner text-center text-white">
                <div className="col-md-8">
                    <h3 className='fw-bold py-3'>Memberships in step arena</h3>
                    <p className='fw-bold'>Unlock Full Access with a Step Arena Membership</p>
                    <p className='fs-6'>Choosing a Step Arena membership means gaining unlimited access to everything we offer—indoor and outdoor Olympic pools, the Spa & Fitness center, exclusive programs, and seasonal events. Whether you’re an elite athlete, a family seeking a healthy lifestyle, or part of an international training team, our membership plans adapt to your needs.</p>
                </div>
            </div>

            {/* Create a Facility Section */}

            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-6 px-0 mb-3 mb-sm-0">
                        <img src={Images.MEMBERSHIP1} alt="" className='w-100' />
                    </div>

                    <div className="col-md-6 p-md-5 p-2 d-flex flex-column justify-content-center">
                        <h4 className='text-primary fw-bold'>What’s Included?</h4>
                        <ul>

                            <li><span className='text-primary fw-bold'>Accommodation </span>in our on-site hotel with direct access to all facilities</li>
                            <li><span className='text-primary fw-bold'>Training sessions </span>in Olympic-standard pools and fitness zones</li>
                            <li><span className='text-primary fw-bold'>Nutritious meals </span>designed for athletic and balanced lifestyles</li>
                            <li><span className='text-primary fw-bold'>Spa & Recovery services </span>to support physical and mental well-being</li>
                            <li><span className='text-primary fw-bold'>Flexible scheduling </span>for both short-term and long-term stays</li>

                        </ul>
                    </div>
                </div>
            </div>


            <div className="container-fluid">
                <div className="row">

                    <div className="col-md-6 p-md-5 p-2 d-flex flex-column justify-content-center">
                        <h4 className='text-primary fw-bold'>IDEA FOR:</h4>
                        <ul>

                            <li><span className='text-primary fw-bold'>Professional & Amateur Athletes </span>preparing for events or rehabilitation</li>
                            <li><span className='text-primary fw-bold'>International Teams & Clubs </span>seeking intensive training camps</li>
                            <li><span className='text-primary fw-bold'>Families </span> looking to combine sport, wellness, and relaxation</li>
                            <li><span className='text-primary fw-bold'>Youth Programs </span>in development stages</li>
                            <li><span className='text-primary fw-bold'>Recreational Visitors </span>interested in a full-service active getaway</li>

                        </ul>
                    </div>

                    <div className="col-md-6 px-0">
                        <img src={Images.MEMBERSHIP2} alt="" className='w-100' />
                    </div>
                </div>
            </div>

            <div className="container-fluid py-5 d-flex justify-content-center bg-primary">
                <div className='col-md-8 text-center text-white'>
                    <h1 className='fw-bold'>Seasonal Offers</h1>
                    <p>Throughout the year, Step Arena provides seasonal promotions and special discounts on our packages—particularly during major events, school holidays, and summer or winter breaks.</p>
                </div>
            </div>
        </>
    )
}

export default MEMBERSHIP;
